import { Tabs } from 'antd';
import './styles.css';

interface IPaginationTabsProps {
    tabs: any;
    setPag: (page: number) => void;
    pag: any;
    setKey: (key: number) => void;
    keyDefault: any;
}
const PaginationTabs = ({ tabs, setPag, pag, setKey, keyDefault }: IPaginationTabsProps) => {
    const handleTabChange = (activeKey: string) => {
        const index = Number(activeKey);
        setPag(index);
        setKey(keyDefault + 1);
    };

    return (
        <Tabs
            activeKey={pag.toString()}
            onChange={handleTabChange}
            type="line"
        >
            {tabs.map((tab: any, index: any) => (
                <Tabs.TabPane
                    tab={tab}
                    key={index.toString()}
                    className={pag === index ? 'tab-selected' : ''}
                />
            ))}
        </Tabs>
    );
};
export default PaginationTabs;